<template>
  <keep-alive include="Category,Search">
    <router-view/>
  </keep-alive>
</template>

<script>
export default {
};
</script>
